export default __webpack_public_path__ + "static/media/sofia-pro-black.fb1726ae.woff2";